import { graphql, PageProps } from "gatsby";
import React, { useCallback, useState } from "react";

import { FragranceMatchmakerSignupQuery } from "../../../../graphql-types";
import { default as GlobalHead } from "../../../components/head";
import Layout from "../../../components/layout";
import {
  CheetahEventHandler,
  useCheetahIFrameEvents,
} from "../../../hooks/useCheetahIFrameEvents";

type Props = PageProps<FragranceMatchmakerSignupQuery>;

// Setting an initial height prevents CLS
const INITIAL_IFRAME_HEIGHT = 1350;

export default function FragranceMatchmakerSignup({ data }: Props) {
  // It's notoriously difficult to set the correct height of iframes. We can achieve
  // this by listening for messages from the iframe when it resizes.
  const [height, setHeight] = useState(INITIAL_IFRAME_HEIGHT);
  const handler = useCallback<CheetahEventHandler>((event) => {
    if (event.action === "resize" && event.event === "frame:resize") {
      setHeight(event.payload.height);
    }
  }, []);

  useCheetahIFrameEvents(handler);

  return (
    <Layout
      absolutePath="https://www.domestos.com/uk/regime-competition.html"
      pageTitle="Domestos Competition Signup"
      metaDescription="Sign up to win a Domestos bundle + additional products
to give your toilet unstoppable fresh fragrance."
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      home={data.website!}
    >
      <h1 className="sr-only">Domestos Competition Signup</h1>
      <iframe
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        allowtransparency="true"
        height={height}
        id="ngxFrame260665"
        src="https://xd.wayin.com/display/container/dc/74790951-3298-49d4-8adc-f55f6da33a11?mode=responsive&scrolling=no"
        title="cheetah-iframe"
        width="100%"
      />
    </Layout>
  );
}

export const query = graphql`
  query FragranceMatchmakerSignup {
    website {
      ...homeFields
    }
  }
`;

export const Head = ({ data }: Props) => {
  return (
    <GlobalHead
      absolutePath="https://www.domestos.com/uk/regime-competition.html"
      pageTitle="Domestos Competition Signup"
      metaDescription="Sign up to win a Domestos bundle + additional products
to give your toilet unstoppable fresh fragrance."
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      home={data.website!}
    />
  );
};
